





















































import { Component, Vue } from "vue-property-decorator";
import AuthModule from "@/store/auth";
import TokenUtil from "@/utils/TokenUtil";
import UserModule from "@/store/user";
import { EditStatus } from "@/types";
import CUserEditForm from "@/components/forms/CUserEditForm.vue";

@Component({
  components: {
    CUserEditForm,
  },
})
export default class UserInfo extends Vue {
  private get me() {
    return AuthModule.me;
  }

  private get editStatus() {
    return EditStatus;
  }

  private get currentEditStatus() {
    return UserModule.editStatus;
  }

  private openEditForm() {
    UserModule.commitEditStatus(EditStatus.Edit);
  }

  private logout() {
    TokenUtil.removeToken();
    AuthModule.commitMe(null);
    this.$router.push("/");
  }
}
